import React, { Component } from "react"
import $ from 'jquery'
import { inject, observer } from 'mobx-react';
import NavViews from '../../stores/NavViews';
import { Menu, Dropdown, Icon } from 'antd';
import DropDownCategoryLeagues from './DropDownCategoryLeagues'

@observer(["CategoriesStore", "CustomRouter", "ViewStore"])

class HeaderCategories extends Component {
    constructor(props) {
        super(props);

        this.state = {

            categories: {},
            categoryCurrently: false
        };

        this.renderCategories = this.renderCategories.bind(this);

    }

    async componentWillMount() {
        let self = this;
        const { CategoriesStore } = this.props;

        CategoriesStore.queryCategories();

    }

    handleClickLeft() {
        var actualScroll = $(".categories-inside-wrap").scrollLeft();
        // To set new position
        $(".categories-inside-wrap").scrollLeft(actualScroll - 50)
    }

    handleClickRight() {
        var actualScroll = $(".categories-inside-wrap").scrollLeft();
        // To set new position
        $(".categories-inside-wrap").scrollLeft(actualScroll + 50)
    }

    renderCategories() {

        const { CategoriesStore, CustomRouter, ViewStore } = this.props;
        const { router: { goTo } } = CustomRouter;
        const { router: { params } } = CustomRouter;

        let categoryList = []
        let categories = Array.from(CategoriesStore.categories.values());

/* //HIGHTLIGHT CURRENT CATEGORY
        if (ViewStore.getCurrentPage == 'Categories') {
            for (let category of categories) {
                if (params.categoryId == category._id) {
                    categoryList.push(
                        <div className="category category-active" key={category._id}>
                            <img onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)} src={category.logoUrl} />
                            <span onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)}>{category.title}</span>
                            <DropDownCategoryLeagues categoryId={category._id} />
                        </div>
                    )
                }
                else {
                    categoryList.push(
                        <div className="category" key={category._id}>
                            <img onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)} src={category.logoUrl} />
                            <span onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)}>{category.title}</span>
                            <DropDownCategoryLeagues categoryId={category._id} />
                        </div>
                    )
                }
            }
        } else {
            for (let category of categories) {
                categoryList.push(
                    <div className="category" key={category._id}>
                        <img onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)} src={category.logoUrl} />
                        <span onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)}>{category.title}</span>
                        <DropDownCategoryLeagues categoryId={category._id} />
                    </div>
                )
            }
        }
        */
       for (let category of categories) {
        categoryList.push(
            <div className="category" key={category._id}>
                <img onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)} src={category.logoUrl} />
                <span onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)}>{category.title}</span>
                <DropDownCategoryLeagues categoryId={category._id} />
            </div>
        )
    }
        return categoryList;
    }

    render() {
        return (
            <div className="categories">
                <div className="arrow-left" onClick={this.handleClickLeft}>
                    <Icon type="left" />
                </div>
                <div className="categories-inside-wrap">
                    {this.renderCategories()}
                </div>
                <div className="arrow-right" onClick={this.handleClickRight}>
                    <Icon type="right" />
                </div>
            </div>
        );
    }

}

export default HeaderCategories;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/HeaderCategories.js